// Paintings with an "Experience the painting ✦" story arc (kept light so catalogue and captions don't load the 3D arcs).
export const STORY_SLUGS = new Set([
  "a-blue-commotion",
  "the-storm-of-whispering-thoughts",
  "the-brooding-mind",
  "marshy-meadows-of-memories",
  "medley",
  "that-home-on-the-way",
  "existence",
  "the-lotus-pond",
  "the-tree-by-the-window",
  "oak-city-winter",
  "sunset-play",
  "tulips",
  "the-orchard",
  "flower-garden",
  "the-butterfly-wing",
  "vasundhara-the-planet",
  "home",
  "hridayaye-shivastishthatu",
  "the-beauty-of-faith",
  "an-evening-by-the-ganges",
  "the-window-of-our-soul",
  "mor-pankh",
  "love-must-feel-like-this",
  "destiny",
  "the-bouquet",
  "the-dream",
  "the-promise",
  "a-summer-sunset",
  "simmering-passion",
]);
export const hasStory = (p) => !!p && STORY_SLUGS.has(p.slug);
